module.exports = __webpack_public_path__ + "static/calendar-582427849147c07b66c782d54ca888ad.png";